export { default } from "./FunctionConfig";
